<template>
  <div>
    <v-btn rounded @click="open()" class="mr-3 primary">
      <v-icon> mdi-checkbox-multiple-blank-outline </v-icon> View Ads
    </v-btn>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-row class="mx-4 mt-4" justify="center" align="center">
        <v-col cols="2">
          <v-btn @click="clearOperation()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="8" class="text-center">
          <v-img
            :src="this.$store.state.agency.agencyLogo"
            width="280px"
            class="mx-auto"
          />
        </v-col>
        <v-col cols="2"> </v-col>
      </v-row>
      <v-row class="mx-4 my-4">
        <v-col cols="12" class="text-center">
          <h3>Ads for Adset</h3>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-card v-for="ad in ads" :key="ad" class="mx-auto my-2" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5 mb-1">
                  {{ ad.creative.title }}
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  ad.creative.body
                }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80">
                <v-img
                  :src="ad.creative.thumbnail_url"
                  :lazy-src="ad.creative.thumbnail_url"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>
            <!-- <v-card-actions>
              <v-btn outlined rounded text class="mx-auto"> View </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: ["ads"],
  data: () => ({
    show: false,
    valid: false,
    overlay: false,
  }),
  methods: {
    //open New Subscribtion Drawer and display over Layer
    open() {
      this.show = !this.show;
    },
    clearOperation() {
      this.reason = "";
      this.show = false;
    },
    validate() {
      this.$refs.form.validate();
    },
  },
};
</script>
